module.exports = __webpack_public_path__ + "static/media/logo-white.88e98225.png";